export default __webpack_public_path__ + "media/images/react_icons/property/coworking-e5bf773fc45f11960e34e2223faf27b2.svg";